import { useQuery } from '@tanstack/react-query';

import { type CppRateCardListFilters, listCppRateCards } from '~/services/LuxLoyalty';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

interface UseSearchCppRateCardsOptions {
  enabled?: boolean;
}

/** Lists CPP rate cards with the given filters (partner/status). */
export function useSearchCppRateCards(filters: CppRateCardListFilters, options: UseSearchCppRateCardsOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: costPerPointQueryKeys.list(filters),
    queryFn: async ({ signal }) => {
      return await listCppRateCards(filters, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
